import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      creative_reports: {
        configuration: {
          header: 'REPORTS.HEADER',
          generate_report: 'REPORTS.GENERATE_REPORT',
          download_report: 'REPORTS.DOWNLOAD_REPORT',
          some_error_occured: 'REPORTS.SOME_ERROR_OCCURRED',
          refresh_page_button: 'REPORTS.REFRESH_PAGE_BUTTON',
          date_range: {
            today: 'REPORTS.DATE_RANGE.today',
            yesterday: 'REPORTS.DATE_RANGE.yesterday',
            last_7_days: 'REPORTS.DATE_RANGE.last_7_days',
            week: 'REPORTS.DATE_RANGE.week',
            last_week: 'REPORTS.DATE_RANGE.last_week',
            month: 'REPORTS.DATE_RANGE.month',
            last_month: 'REPORTS.DATE_RANGE.last_month',
            year: 'REPORTS.DATE_RANGE.year',
          },
          group_by: {
            date: {
              group_by_day: 'REPORTS.GROUP_BY.group_by_day',
              group_by_week: 'REPORTS.GROUP_BY.group_by_week',
              group_by_month: 'REPORTS.GROUP_BY.group_by_month',
              group_by_alltime: 'REPORTS.GROUP_BY.group_by_alltime',
            },
            affiliate_params: {
              label: 'REPORTS.GROUP_BY.AFFILIATE.LABEL',
              add_grouping_btn: 'REPORTS.GROUP_BY.AFFILIATE.ADD_GROUPING_BTN',
              group_by_merchant: 'REPORTS.GROUP_BY.group_by_merchant',
              group_by_creative: 'REPORTS.GROUP_BY.group_by_creative',
              group_by_affiliate: 'REPORTS.GROUP_BY.group_by_affiliate',
              group_by_tracker: 'REPORTS.GROUP_BY.group_by_tracker',
              group_by_anid: 'REPORTS.GROUP_BY.group_by_anid',
              group_by_manager: 'REPORTS.GROUP_BY.group_by_manager',
              group_by_department: 'REPORTS.GROUP_BY.group_by_department',
              group_by_traffic_source: 'REPORTS.GROUP_BY.group_by_traffic_source',
            },
            per_page: {
              rows_per_page: 'REPORTS.GROUP_BY.rows_per_page',
            },
          },
          segments: {
            all_players: 'REPORTS.SEGMENTS_ALL_PLAYERS',
            no_name: 'REPORTS.SEGMENTS_NO_NAME',
            add_new_element: 'REPORTS.SEGMENTS_ADD_NEW_ELEMENT',
            tabs: {
              merchant_ids: 'REPORTS.SEGMENTS_TABS.merchant_ids',
              creatives: 'REPORTS.SEGMENTS_TABS.creatives_for_creatives_report',
              anid: 'REPORTS.SEGMENTS_TABS.anids_for_creatives_report',
              managers: 'REPORTS.SEGMENTS_TABS.managers',
              departments: 'REPORTS.SEGMENTS_TABS.departments',
              affiliates: 'REPORTS.SEGMENTS_TABS.affiliates',
              tracker_traffic_source: 'REPORTS.SEGMENTS_TABS.tracker_traffic_source',
              trackers: 'REPORTS.SEGMENTS_TABS.trackers',
              name: 'REPORTS.SEGMENTS_TABS_NAME',
            },
          },
        },
        dialog_window: {
          remove: {
            title: 'REPORTS.DIALOG_TITLE',
            question: 'REPORTS.DIALOG_QUESTION',
            yes: 'REPORTS.DIALOG_YES',
            no: 'REPORTS.DIALOG_NO',
          },
        },
        result: {
          header: 'REPORTS.RESULT_HEADER',
          subtotal: 'REPORTS.SUB_TOTAL_ENTRIES',
          total: 'REPORTS.TOTAL_ENTRIES',
        },
      },
    },
  }));
}
